import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
    rightMargin: {
        marginRight: '5%',
    },
}));

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 40,
        height: 22,
        padding: 2.3,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    disabled: {
        '&$checked': {
            '& + $track': {
                opacity: 0.5,
            },
        },
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

function AdvancedSwitch(props) {
    const classes = useStyles();

    if (props.advancedRequiredMsg) {
        return (
            <Tooltip title={props.advancedRequiredMsg}>
                <FormControlLabel
                    label="Advanced"
                    labelPlacement="start"
                    classes={{ label: classes.rightMargin }}
                    control={<AntSwitch disabled={true} color="primary" size="small" checked={props.checked} />}
                />
            </Tooltip>
        );
    } else {
        return (
            <FormControlLabel
                label="Advanced"
                labelPlacement="start"
                classes={{ label: classes.rightMargin }}
                control={<AntSwitch color="primary" size="small" checked={props.checked} onChange={props.onToggle} />}
            />
        );
    }
}
export default AdvancedSwitch;
